// users
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const CLEAR_USERS = 'CLEAR_USERS';

// user
export const SELECT_USER = 'SELECT_USER';
export const CLEAR_SELECTED_USER = 'CLEAR_SELECTED_USER';

// pagination
export const SET_USERS_SEARCH = 'SET_USERS_SEARCH';
export const SET_USERS_PAGE_SIZE = 'SET_USERS_PAGE_SIZE';
export const NEXT_USERS_PAGE = 'NEXT_USERS_PAGE';
export const PREV_USERS_PAGE = 'PREV_USERS_PAGE';
